import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { WindowPlainObject } from '../plainObjects/window.plainObject';
import { SchemaUtil } from '../utils/schema.util';
import { ExpressionColumnPlainObject } from '../plainObjects/expressionColumn.plainObject';
import { MatchFunctionUtil } from '../utils/matchFunction.util';
import { SortExpressionPlainObject } from '../plainObjects/sortExpression.plainObject';

export class WindowVisitor extends BaseTransformationVisitor {
    private get _windowTransformation(): WindowPlainObject {
        return this.transformation as WindowPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitAssignment(assignment: any): ExpressionColumnPlainObject {
        const derivedColumn = new ExpressionColumnPlainObject();
        derivedColumn.name = SchemaUtil.getColumnName(assignment.columnIdentifier());
        derivedColumn.expression = this._getText(assignment.expression());
        this._windowTransformation.columns.push(derivedColumn);
        return derivedColumn;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitTransientAssignment(assignment: any): void {
        const visitAssignment = this.visitAssignment(assignment);
        visitAssignment.transient = true;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitBasicFunction(context: any): void {
        if (context.basicName().getText() === 'asc' || context.basicName().getText() === 'desc') {
            const sortExpression = new SortExpressionPlainObject();
            sortExpression.ascending = this._getText(context.basicName()) === 'asc';
            const expressions = context.expression();
            sortExpression.expression = expressions[0] ? this._getText(expressions[0]) : '';
            sortExpression.nullsFirst = expressions[1] && this._getText(expressions[1]) === 'true';
            this._windowTransformation.sortColumns.push(sortExpression);
        } else if (context.basicName().getText() === 'over') {
            MatchFunctionUtil.addGroupByColumns(this._windowTransformation, context);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitMetaFunctionExpr(context: any): void {
        if (context.metafunction().basicName().getText() === 'over') {
            MatchFunctionUtil.addGroupByColumns(this._windowTransformation, context.metafunction());
        } else if (context.metafunction().basicName().getText() === 'each') {
            MatchFunctionUtil.addColumnPatternColumns(this._windowTransformation, this._tokenStream, context);
        }
    }
}
